<template>
  <span v-bind:style="{ background: this.instance[this.field.key] }">
      {{ this.instance[this.field.key] }}
  </span>
</template>

<script>

export default {
  props: {
    instance: {
      type: Object,
      required: true
    },

    field: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="sass" scoped>
span
  color: #ffffff
</style>



// WEBPACK FOOTER //
// src/components/ui/DatatableElements/ColorElement.vue